module.exports = __webpack_public_path__ + "static/media/1031247.1921420a.jpg";